import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M22.5 4.5H11.74a.5.5 0 0 1-.45-.28l-.95-1.89A1.5 1.5 0 0 0 9 1.5H1.5A1.5 1.5 0 0 0 0 3v18a1.5 1.5 0 0 0 1.5 1.5h21A1.5 1.5 0 0 0 24 21V6a1.5 1.5 0 0 0-1.5-1.5"
    }, null, -1)
  ]));
}
const Folder = { render };
export {
  Folder as default,
  render
};
//# sourceMappingURL=Folder.svg.js.map
